import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { HomeService } from './home.service';

export interface HomeStateModel {
  loading: boolean;
}

@State<HomeStateModel>({
  name: 'home',
  defaults: {
    loading: false,
  },
})
@Injectable()
export class HomeState {
  public constructor(private readonly _homeService: HomeService) {}

  @Selector()
  public static loading({ loading }: HomeStateModel): boolean {
    return loading;
  }
}
